import ActivityType from './ActivityType';

const ActivityTypeNames = {
    /**
     * indicator for Txp Activity
     */
    TxpActivity: 'TxpActivity',

    /**
     * Flight Departure activity type
     */
    flightdeparture: ActivityType.FlightDeparture,

    /**
     * Hotel checkin activity type
     */
    hotelcheckin: ActivityType.HotelCheckin,

    /**
     * Hotel checkout activity type
     */
    hotelcheckout: ActivityType.HotelCheckout,

    /**
     * Invoice Due activity type
     */
    invoicedue: ActivityType.InvoiceDue,

    /**
     * Invoice Scheduled activity type
     */
    invoicescheduled: ActivityType.InvoiceScheduled,

    /**
     * Parcel Delivery activity type
     */
    parceldelivery: ActivityType.ParcelDelivery,

    /**
     * Rental car pick up activity type
     */
    rentalcarpickup: ActivityType.RentalCarPickup,

    /**
     * Rental car drop off activity type
     */
    rentalcardropoff: ActivityType.RentalCarDropOff,

    /**
     * Dining activity type
     */
    dining: ActivityType.Dining,

    /**
     * Event activity type
     */
    miscevent: ActivityType.EventActivityType,

    /**
     * Service reservation activity type
     */
    serviceappointment: ActivityType.ServiceAppointment,
};

export default ActivityTypeNames;
